
import { defineComponent, reactive, toRefs } from "vue";
import Keyboard from "@/components/Keyboard.vue";
export default defineComponent({
  name: "App",
  components: { Keyboard },
  setup() {
    const state = reactive({
      lastKey: {
        code: " ",
        key: " ",
        keyCode: " ",
      },
      his: [] as string[],
    });
    return {
      ...toRefs(state),
      onLastKey: (data: { code: string; key: string; keyCode: string }) => {
        state.lastKey = data;
        if (state.his.length >= 10) {
          state.his.pop();
        }
        state.his.unshift(data.code);
      },
    };
  },
});
